export enum Breakpoints {
  SCREEN_SM = 576,
  SCREEN_MD = 768,
  SCREEN_LG = 992,
  SCREEN_XL = 1200,
  SCREEN_XXL = 1400,
  SCREEN_XXX = 1600,
}
